module.exports = __webpack_public_path__ + "assets/img/00077.3243f877.png";